// Copyright (c) 2017 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../shared/state/busy-counter';
import LaborAdditiveSummary, {getDefaultState as getLaborAdditiveSummaryDefaultState} from '@deere/cps-it.warranty-model-factory/lib/labor-additive-summary';
import Notifications, {getDefaultState as getNotificationsDefaultState} from './notifications';
import SearchByDropDown, {getDefaultState as getSearchByDropDownDefaultState} from './search-by-dropdown';
import Wip, {getDefaultState as getWipDefaultState} from './wip';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import LaborAdditiveSummaries from './labor-additive-summaries';
import t from 'tcomb';

const Home = t.struct({
    busyCounter: BusyCounter,
    claimStatuses: t.list(KeyValuePair),
    isMoreSummaryVisible: t.Boolean,
    isVisible: t.Boolean,
    laborAdditiveSummaries: LaborAdditiveSummaries,
    laborAdditiveSummary: LaborAdditiveSummary,
    notifications: Notifications,
    searchByDropDown: SearchByDropDown,
    searchQueryString: t.String,
    wip: Wip
}, {
    name: 'Home',
    strict: true
});

export const getDefaultState = () =>
    new Home({
        busyCounter: getBusyCounterDefaultState(),
        claimStatuses: [],
        isMoreSummaryVisible: false,
        isVisible: false,
        laborAdditiveSummaries: [],
        laborAdditiveSummary: getLaborAdditiveSummaryDefaultState(),
        notifications: getNotificationsDefaultState(),
        searchByDropDown: getSearchByDropDownDefaultState(),
        searchQueryString: '',
        wip: getWipDefaultState()
    });

export default Home;



// WEBPACK FOOTER //
// ./src/home-page/state/index.js